<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar },{ rtl: $route.meta.rtlActive }]">
    <notifications></notifications>
    <side-bar :title="$store.getters.config.company">
      <template slot="links">
        <sidebar-item :link="{ name: $t('pages.dashboard'), icon: 'home', path: '/dashboard' }" />

        <sidebar-item :link="{ name: $t('pages.user'), icon: 'perm_identity', path: '/user' }">
          <sidebar-item :link="{ name: $t('pages.user_profile'), path: '/user/profile' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.finances'), icon: 'account_balance_wallet', path: '/finances' }">
          <sidebar-item :link="{ name: $t('pages.balances'), path: '/finances/balances' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.accounts'), icon: 'settings', path: '/accounts' }" />

        <sidebar-item :link="{ name: $t('pages.sender'), icon: 'alternate_email', path: '/sender' }" />

        <sidebar-item :link="{ name: $t('pages.contacts'), icon: 'contact_mail', path: '/contacts' }">
          <sidebar-item :link="{ name: $t('pages.address_book_group'), path: '/address_book/group' }" />
          <sidebar-item :link="{ name: $t('pages.black_list_group'), path: '/black_list/group' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.distribution_template'), icon: 'description', path: '/template' }">
          <sidebar-item :link="{ name: 'SMS', path: '/template/sms' }" />
          <sidebar-item :link="{ name: 'Call', path: '/template/call' }" />
          <sidebar-item :link="{ name: 'Email', path: '/template/email' }" />
          <sidebar-item :link="{ name: 'Push', path: '/template/push' }" />
          <sidebar-item :link="{ name: 'Viber', path: '/template/viber' }" />
          <sidebar-item :link="{ name: 'WhatsApp', path: '/template/whatsapp' }" />
          <sidebar-item :link="{ name: 'Telegram OTP', path: '/template/telegram_otp' }" />
          <sidebar-item :link="{ name: 'Custom', path: '/template/custom' }" />
          <sidebar-item :link="{ name: 'Mail Notify', path: '/template/mail_notify' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.distribution'), icon: 'reply_all', path: '/distribution' }">
          <sidebar-item :link="{ name: $t('pages.distribution_list'), path: '/distribution' }" />
          <sidebar-item :link="{ name: 'SMS', path: '/distribution/sms/new' }" />
          <sidebar-item :link="{ name: 'Call', path: '/distribution/call/new' }" />
          <sidebar-item :link="{ name: 'Email', path: '/distribution/email/new' }" />
          <sidebar-item :link="{ name: 'Push', path: '/distribution/push/new' }" />
          <sidebar-item :link="{ name: 'Viber', path: '/distribution/viber/new' }" />
          <sidebar-item :link="{ name: 'WhatsApp', path: '/distribution/whatsapp/new' }" />
          <sidebar-item :link="{ name: 'Custom', path: '/distribution/custom/new' }" />
          <sidebar-item :link="{ name: 'Mail Notify', path: '/distribution/mail_notify/new' }" />
          <sidebar-item :link="{ name: 'Telegram OTP', path: '/telegram-otp/send' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.report_detailed'), icon: 'query_stats', path: '/report/detailed' }">
          <sidebar-item :link="{ name: 'SMS', path: '/report/detailed/sms' }" />
          <sidebar-item :link="{ name: 'Call', path: '/report/detailed/call' }" />
          <sidebar-item :link="{ name: 'Email', path: '/report/detailed/email' }" />
          <sidebar-item :link="{ name: 'Push', path: '/report/detailed/push' }" />
          <sidebar-item :link="{ name: 'Viber', path: '/report/detailed/viber' }" />
          <sidebar-item :link="{ name: 'WhatsApp', path: '/report/detailed/whatsapp' }" />
          <sidebar-item :link="{ name: 'Telegram OTP', path: '/report/detailed/telegram_otp' }" />
          <sidebar-item :link="{ name: 'Custom', path: '/report/detailed/custom' }" />
          <sidebar-item :link="{ name: 'Mail Notify', path: '/report/detailed/mail_notify' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.report_group'), icon: 'leaderboard', path: '/report/group' }">
          <sidebar-item :link="{ name: 'SMS', path: '/report/group/sms' }" />
          <sidebar-item :link="{ name: 'Call', path: '/report/group/call' }" />
          <sidebar-item :link="{ name: 'Email', path: '/report/group/email' }" />
          <sidebar-item :link="{ name: $t('pages.report_group_email_events'), path: '/report/group/email/events' }" />
          <sidebar-item :link="{ name: 'Push', path: '/report/group/push' }" />
          <sidebar-item :link="{ name: 'Viber', path: '/report/group/viber' }" />
          <sidebar-item :link="{ name: 'WhatsApp', path: '/report/group/whatsapp' }" />
          <sidebar-item :link="{ name: 'Telegram OTP', path: '/report/group/telegram_otp' }" />
          <sidebar-item :link="{ name: 'Custom', path: '/report/group/custom' }" />
          <sidebar-item :link="{ name: 'Mail Notify', path: '/report/group/mail_notify' }" />
          <sidebar-item :link="{ name: $t('pages.report_group_summary'), path: '/report/group/summary' }" />
        </sidebar-item>

        <sidebar-item :link="{ name: $t('pages.report_export'), icon: 'download', path: '/report/export' }" />

      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <loading :active="isLoading"
                 :can-cancel="true" color="steelblue"
                 :is-full-page="true"></loading>
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  import Loading from 'vue-loading-overlay/dist/vue-loading.min';
  import 'vue-loading-overlay/dist/vue-loading.css';
  /* eslint-disable no-new */
  import PerfectScrollbar from "perfect-scrollbar";
  import "perfect-scrollbar/css/perfect-scrollbar.css";
  import {mapGetters} from "vuex";
  import TopNavbar from "./TopNavbar.vue";
  import ContentFooter from "./ContentFooter.vue";
  import { ZoomCenterTransition } from "vue2-transitions";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  export default {
    components: {
      Loading,
      TopNavbar,
      ContentFooter,
      ZoomCenterTransition
    },
    computed:{
      ...mapGetters([
        'isLoading'
      ])
    },
    data() {
      return {
        sidebarMini: true,
        sidebarImg: true
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      minimizeSidebar() {
        if (this.$sidebar) {
          this.$sidebar.toggleMinimize();
        }
      }
    },
    mounted() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        // initScrollbar("sidebar");
        initScrollbar("sidebar-wrapper");
        // initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
      if (localStorage.getItem('sidebar-mini') === 'true'){
        docClasses.remove("sidebar-mini");
      }
    },
    watch: {
      sidebarMini() {
        this.minimizeSidebar();
      }
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }
  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }
  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
